import { AbstractControl, ValidatorFn } from '@angular/forms';

export function forbiddenWordsValidator(words: string[]): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    for (const keyword of (control.value || [])) {
      if (words.find(word => word === keyword)) {
        return {forbiddenWords: {value: control.value, words}};
      }
    }

    return null;
  };
}
